import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-content-filter-cabinet',
    templateUrl: './content-filter.component.html',
    styleUrl: './content-filter.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class ContentFilterCabinetComponent {

}
